import {Component, Input, OnInit} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Component({
  selector: 'nc-language-picker',
  templateUrl: './nc-language-picker.component.html',
  styleUrls: ['./nc-language-picker.component.scss']
})
export class NcLanguagePickerComponent implements OnInit {
  @Input() active: string;
  @Input() languages: string[];
  @Input() onChange: (language: string) => void;
  @Input() id: string;

  isMobile$: Observable<boolean>;

  constructor(private breakpointObserver: BreakpointObserver) {
  }

  ngOnInit(): void {
    this.isMobile$ = this.breakpointObserver
      .observe(['(max-width: 650px)'])
      .pipe(map(state => state.matches));
  }

}
